import API from './constant'
import { IQuestion } from '../types/question';

export async function userLogin(data: { username: string; password: string }) {
    try {
        const response = await API.post(
            'api/token/',
            data
        );
        return response.data;

    } catch (err) {
        console.log(err);
        throw err as any;
    }
}

export async function requestPasswordReset(data: { email?: string; username?: string }) {
    try {
        const response = await API.post('api/password/reset/', data);
        return response.data;
    } catch (err) {
        console.log(err);
        return err as any;
    }
}

export async function confirmPasswordReset(data: { uid: string; token: string; new_password: string }) {
    try {
        const response = await API.post('api/password/reset/confirm/', data);
        return response.data;
    } catch (err) {
        console.log(err);
        return err as any;
    }
}

export async function getStudents(toBeValidated: string | null, grade_id: string) {
    try {
        const response = await API.get(
            `api/school/students/bygrade/${grade_id}/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        return response.data

    } catch (err) {
        console.log(err)
        return err
    }

}

export async function getStudentProfile(toBeValidated: string | null, stud_id: string | undefined) {
    try {
        const response = await API.get(
            `api/school/student/${stud_id}/profile/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        return response.data

    } catch (err) {
        console.log(err)
        return err
    }

}

export async function getStudentResults(toBeValidated: string | null, stud_id: string | undefined) {
    try {
        const response = await API.get(
            `api/school/student/${stud_id}/results/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        return response.data

    } catch (err) {
        console.log(err)
        return err
    }

}

export async function getStudentResult(toBeValidated: string | null, stud_id: string | undefined, res_id: number | undefined) {
    try {
        const response = await API.get(
            `api/school/student/${stud_id}/result/${res_id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        return response.data

    } catch (err) {
        console.log(err)
        return err
    }

}

export async function getStudentResultChapters(toBeValidated: string | null, stud_id: string | undefined, res_id: number | undefined) {
    try {
        const response = await API.get(
            `api/school/student/${stud_id}/result/${res_id}/chapters/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        return response.data

    } catch (err) {
        console.log(err)
        return err
    }

}

// Institution join requests (school admins)
export async function getInstitutionRequests(toBeValidated: string | null) {
    try {
        const response = await API.get(`api/school/requests/`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${toBeValidated}`
            }
        });
        return response.data;
    } catch (err) {
        console.error(err);
        throw err;
    }
}

export async function approveInstitutionRequest(toBeValidated: string | null, req_id: number) {
    try {
        const response = await API.post(`api/school/requests/${req_id}/approve/`, {}, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${toBeValidated}`
            }
        });
        return response.data;
    } catch (err) {
        console.error(err);
        throw err;
    }
}

export async function denyInstitutionRequest(toBeValidated: string | null, req_id: number) {
    try {
        const response = await API.post(`api/school/requests/${req_id}/deny/`, {}, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${toBeValidated}`
            }
        });
        return response.data;
    } catch (err) {
        console.error(err);
        throw err;
    }
}

export async function getGrades(toBeValidated: string | null) {
    try {
        const response = await API.get(
            'api/school/grades/',
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        
        return response.data

    } catch (err) {
        console.log(err)
        return err
    }

}

export async function getGradeSubjects(toBeValidated: string | null, grade_id: string) {
    try {
        const response = await API.get(
            `api/school/grades/${grade_id}/subjects/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        
        return response.data

    } catch (err) {
        
        return Promise.reject(new Error('Oh no!'))
    }

}

export async function submitSchoolAddExam(data: {toBeValidated: string | null, data: FormData}) {
    try {
        // Map legacy FormData fields to new backend schema
        const name = (data.data.get('name') as string) ?? '';
        const subjectIdRaw = data.data.get('subject_id') as string | null;
        const timeRaw = data.data.get('time') as string | null;
        const gradeIdRaw = data.data.get('grade_id') as string | null;
        const examScopeRaw = data.data.get('exam_scope') as string | null;
        const nationalExamRaw = data.data.get('national_exam') as string | null;
        const coursesRaw = data.data.get('courses') as string | null;
        let coursesArr: number[] | undefined = undefined;
        if (coursesRaw) {
            try {
                // Try JSON parse first (we append JSON string from the UI)
                const parsed = JSON.parse(coursesRaw);
                if (Array.isArray(parsed)) {
                    coursesArr = parsed.map((v) => Number(v)).filter((n) => !Number.isNaN(n));
                }
            } catch (e) {
                // fallback: comma-separated
                try {
                    coursesArr = (coursesRaw || '').split(',').map((x) => Number(x.trim())).filter((n) => !Number.isNaN(n));
                } catch (e2) {
                    coursesArr = undefined;
                }
            }
        }

        const payload = {
            name: name,
            price: 0,
            subject: subjectIdRaw ? Number(subjectIdRaw) : undefined,
            // backend expects minutes in 'time' (we'll send as 'time' to be picked up by view)
            time: timeRaw ? Number(timeRaw) : undefined,
            grade: gradeIdRaw ? Number(gradeIdRaw) : undefined,
            courses: coursesArr,
            // optional scope and national exam id
            exam_scope: examScopeRaw ? examScopeRaw : undefined,
            national_exam: nationalExamRaw ? Number(nationalExamRaw) : undefined,
        } as any;

        const response = await API.post(
            `api/school/add-exam/`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${data.toBeValidated}`
                },
            }
        );
        // Normalize response to legacy shape expected by components
        const id = (response.data && (response.data.id ?? response.data.exam_id)) as number | undefined;
        return { done: 'done', exam_id: id } as any;
    } catch (err) {
        console.log(err);
        return err as any;
    }
}


export async function getExamData(toBeValidated: string | null, exam_id: string | undefined) {
    try {
        const response = await API.get(
            `api/school/exam-detail/${exam_id}/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        const raw = response.data as any;
        // Normalize to legacy shape expected by components
        return { exam: { ...raw, time: raw?.time_given } } as any;

    } catch (err) {
        console.log(err)
        return err
    }

}


export async function addSchoolExamQuestions(data: {toBeValidated: string | null, exam_id: string, data: IQuestion[]}) {
    try {
        const response = await API.post(
            `api/school/exam-detail/${data.exam_id}/add-questions/`,
            (data.data),
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${data.toBeValidated}`
                },

            }
        );
        
        return response.data

    } catch (err) {
        console.log(err)
        return err
    }

}


// POST a chunk of text to the server to extract questions via user's API key (server proxies to Gemini)
export async function extractQuestionsChunk(data: { toBeValidated: string | null; text: string; exam_id?: number }) {
    try {
        const payload: any = { text: data.text };
        if (typeof data.exam_id === 'number') payload.exam_id = data.exam_id;
        const response = await API.post(
            `api/school/extract-questions/`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${data.toBeValidated}`
                }
            }
        );
        return response.data;
    } catch (err) {
        console.error('extractQuestionsChunk error', err);
        throw err;
    }
}



export async function getExamQuestionData(toBeValidated: string | null, exam_id: string | undefined) {
    try {
        const response = await API.get(
            `api/school/exam-detail/${exam_id}/get-questions/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        const arr = (response.data || []) as any[];
        // Preserve legacy mapped shape for components that expect it, but also
        // provide the full raw objects which include explanation, reference, corrected_answer, etc.
        const mapped = arr.map((q) => ({
            id: q.id,
            ques: q.ques,
            choice_a: q.option1,
            choice_b: q.option2,
            choice_c: q.option3,
            choice_d: q.option4,
            ans: q.correct_ans,
            chapter_name: q.chapter_name ?? null,
            chapter_unit: q.chapter_unit ?? null,
            chapter_id: q.chapter_id ?? null,
        }));
        return { questions: mapped, full: arr } as any;

    } catch (err) {
        console.log(err)
        return err
    }

}


export async function getExamQuestionStatus(toBeValidated: string | null, exam_id: string | undefined) {
    try {
        const response = await API.get(
            `api/school/exam-detail/${exam_id}/get-status/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        const active = !!(response.data && (response.data as any).active);
        return { stat: active ? 'Active' : 'Draft', active } as any;

    } catch (err) {
        console.log(err)
        return err
    }

}


export async function changeExamStatus(data: {toBeValidated: string | null, exam_id: string, status: 'Active' | 'Draft'}) {
    
    try {
        const response = await API.post(
            `api/school/exam-detail/${data.exam_id}/change-status/`,
            { status: data.status },
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${data.toBeValidated}`
                },

            }
        );
        
        return response.data

    } catch (err) {
        console.log(err)
        return err
    }

}


export async function getExamChapters(toBeValidated: string | null, exam_id: string | undefined) {
    try {
        const response = await API.get(
            `api/school/exam-detail/${exam_id}/get-chapters/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        
        return { chapters: response.data } as any;

    } catch (err) {
        console.log(err)
        return err
    }

}

export async function getAssignChaptersByAIRag(toBeValidated: string | null, exam_id: string | undefined, grade_ids: number[]) {
    try {
        const response = await API.post(
            `api/school/exam-detail/${exam_id}/assign-chapters-ai/`,
            { grade_ids },
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },
            }
        );
        // Normalize response to match getExamChapters shape
        return { chapters: response.data?.catalog || [] } as any;
    } catch (err) {
        console.log(err);
        return err;
    }
}

export async function changeAddQuestionChapter(data: {toBeValidated: string | null, exam_id: string, data: {[code: number]: string}}) {
    try {
        const entries = Object.entries(data.data || {});
        for (const [qid, chap] of entries) {
            await API.post(
                `api/school/exam-detail/${data.exam_id}/add-change-chapter/`,
                { question: Number(qid), chapter: chap === '-1' ? null : Number(chap) },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${data.toBeValidated}`
                    },
                }
            );
        }
        return { stat: 'done' } as any;
    } catch (err) {
        console.log(err)
        return err
    }
}


export async function schoolChangeAddQuestion(data: {toBeValidated: string | null, exam_id: string, data: any}) {
    try {
        const raw = data.data || {};
        const payload: any = {};
        // Backend expects 'question' id key
        if (raw.question != null) payload.question = raw.question;
        else if (raw.id != null) payload.question = raw.id;
        // Map allowed fields
        if (raw.ques != null) payload.ques = raw.ques;
        if (raw.choice_a != null) payload.choice_a = raw.choice_a;
        if (raw.choice_b != null) payload.choice_b = raw.choice_b;
        if (raw.choice_c != null) payload.choice_c = raw.choice_c;
        if (raw.choice_d != null) payload.choice_d = raw.choice_d;
        if (raw.ans != null) payload.ans = raw.ans;
    // include optional explanation and reference if provided
    if (raw.explanation != null) payload.explanation = raw.explanation;
    if (raw.reference != null) payload.reference = raw.reference;

        const response = await API.post(
            `api/school/exam-detail/${data.exam_id}/change-question/`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${data.toBeValidated}` 
                },
            }
        );
        return response.data
    } catch (err) {
        console.log(err)
        return err
    }
}


export async function getExamsList(toBeValidated: string | null, page_no: string | null, grade_id: string | null, sub_id: string | null, search?: string | null) {
    try {
        const page = page_no ?? '1';
        const params = new URLSearchParams();
        params.set('page', page);
        if (search && search.trim()) params.set('search', search.trim());
        const query = params.toString();
        // Debug: log the request parameters so we can verify what grade/sub values are sent
        try {
            // eslint-disable-next-line no-console
            console.log(`[getExamsList] Fetching exams with grade_id=${grade_id}, sub_id=${sub_id}, page=${page}, search=${search}`);
        } catch (e) {
            // ignore logging failures in environments where console is not available
        }

        const response = await API.get(
            `api/school/exam-list/${grade_id}/${sub_id}/?${query}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },

            }
        );
        const raw = response.data as any;
        const exams = raw.exams.map((exam: any) => ({
            ...exam,
            time_given: exam.time_given,
        }));
        return { ...raw, exams };

    } catch (err) {
        console.log(err)
        return err
    }

}

export async function editExamInfo(data: { toBeValidated: string | null, exam_id: string, payload: { name?: string; time_minutes?: number | string; time?: number | string } }) {
    try {
        const response = await API.post(
            `api/school/exam-detail/${data.exam_id}/edit-info/`,
            data.payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${data.toBeValidated}`,
                },
            }
        );
        const raw = response.data as any;
        return { exam: { ...raw, time: raw?.time_given } } as any;
    } catch (err) {
        console.log(err);
        return err as any;
    }
}

// Admin - Users
export type AdminUser = {
    id: number;
    username: string;
    email: string;
    first_name: string;
    last_name: string;
    is_active: boolean;
    is_superuser: boolean;
};

export async function adminGetUsers(params?: { page?: number; page_size?: number; search?: string }) {
    const page = params?.page ?? 1;
    const page_size = params?.page_size ?? 10;
    const search = params?.search ? `&search=${encodeURIComponent(params.search)}` : '';
    const url = `api/admin/users/?page=${page}&page_size=${page_size}${search}`;
    const res = await API.get(url);
    const raw = res.data as any;
    if (Array.isArray(raw)) {
        return { count: raw.length, next: null, previous: null, results: raw } as { count: number; next: string | null; previous: string | null; results: AdminUser[] };
    }
    // if backend is paginated already
    const results = Array.isArray(raw?.results) ? raw.results : [];
    const count = typeof raw?.count === 'number' ? raw.count : results.length;
    return { count, next: raw?.next ?? null, previous: raw?.previous ?? null, results } as { count: number; next: string | null; previous: string | null; results: AdminUser[] };
}

export async function adminCreateUser(payload: { username: string; password?: string; email?: string; first_name?: string; last_name?: string; is_active?: boolean; is_superuser?: boolean; }) {
    const res = await API.post('api/admin/users/', payload);
    return res.data as AdminUser;
}

export async function adminUpdateUser(id: number, patch: Partial<{ username: string; password: string; email: string; first_name: string; last_name: string; is_active: boolean; is_superuser: boolean; }>) {
    const res = await API.patch(`api/admin/users/${id}/`, patch);
    return res.data as AdminUser;
}

export async function adminDeleteUser(id: number) {
    const res = await API.delete(`api/admin/users/${id}/`);
    return res.data;
}

// Admin - Exams transfer
export async function adminTransferExam(examId: number, payload: { target_institution_id: number; replicate_chapters?: boolean; replicate_questions?: boolean }) {
    const res = await API.post(`api/admin/exams/${examId}/transfer/`, payload);
    return res.data as { detail: string; exam: any };
}

// Admin - Exams list
export type AdminExamListItem = {
    id: number;
    name: string;
    status?: string;
    time_given?: number | null;
    exam_scope?: string;
    national_exam?: number | null;
    subject_id?: number | null;
    subject_name?: string | null;
    course_id?: number | null;
    course_name?: string | null;
    creator_id?: number;
    creator_username?: string;
    institution_id?: number | null;
    institution_name?: string | null;
    created?: string;
    updated?: string;
};
export async function adminGetExams(params?: { page?: number; page_size?: number; search?: string; institution?: number | '' | null; grade?: number | '' | null; subject?: number | '' | null; sort?: string; }) {
    const page = params?.page ?? 1;
    const page_size = params?.page_size ?? 50;
    const usp = new URLSearchParams();
    usp.set('page', String(page));
    usp.set('page_size', String(page_size));
    if (params?.search && params.search.trim()) usp.set('search', params.search.trim());
    if (params?.institution) usp.set('institution', String(params.institution));
    if (params?.grade) usp.set('grade', String(params.grade));
    if (params?.subject) usp.set('subject', String(params.subject));
    if (params?.sort) usp.set('sort', params.sort);
    const url = `api/admin/exams/?${usp.toString()}`;
    const res = await API.get(url);
    const raw = res.data as any;
    const results = Array.isArray(raw?.results) ? raw.results : (Array.isArray(raw) ? raw : []);
    const count = typeof raw?.count === 'number' ? raw.count : results.length;
    return { count, results } as { count: number; results: AdminExamListItem[] };
}

// Admin - Institutions list (basic)
export type AdminInstitutionBasic = { id: number; name: string; inst_type: 'school' | 'college' | 'university' };
export async function adminListInstitutionsBasic() {
    const res = await API.get('api/admin/schools/');
    const items = (res.data || []) as any;
    // When the backend returns a list, return it; when it returns a paginated dict, map results
    const arr = Array.isArray(items) ? items : (items.results || []);
    return arr.map((i: any) => ({ id: i.id, name: i.name, inst_type: i.inst_type })) as AdminInstitutionBasic[];
}

// Admin - Schools
export type AdminCreatorType = { id: number; name: string };
export type AdminSchool = { id: number; name: string; creator_type: number; creator_type_name: string };
export type AdminStudentBrief = { id: number; name: string; grade: string };

export async function adminGetCreatorTypes() {
    const res = await API.get('api/admin/creator-types/');
    const arr = (res.data || []) as any[];
    const toNum: Record<string, number> = { school: 1, college: 2, university: 3 };
    return arr.map((i) => ({ id: toNum[String(i.id)] ?? 0, name: i.name })) as AdminCreatorType[];
}

export async function adminGetSchools(params?: { page?: number; page_size?: number; search?: string }) {
    const page = params?.page ?? 1;
    const page_size = params?.page_size ?? 10;
    const search = params?.search ? `&search=${encodeURIComponent(params.search)}` : '';
    const url = `api/admin/schools/?page=${page}&page_size=${page_size}${search}`;
    const res = await API.get(url);
    const raw = res.data as any;
    const toNum: Record<string, number> = { school: 1, college: 2, university: 3 };
    const toName: Record<string, string> = { school: 'School', college: 'College', university: 'University' };
    const arr = Array.isArray(raw) ? raw : (Array.isArray(raw?.results) ? raw.results : []);
    const mapped = (arr as any[]).map((i) => {
        const t = String(i.inst_type ?? i.creator_type_name ?? '').toLowerCase();
        const creator_type = toNum[t] ?? 0;
        const creator_type_name = toName[t] ?? (i.creator_type_name ?? '');
        return { id: i.id, name: i.name, creator_type, creator_type_name } as AdminSchool;
    });
    const count = typeof raw?.count === 'number' ? raw.count : mapped.length;
    return { count, next: raw?.next ?? null, previous: raw?.previous ?? null, results: mapped } as { count: number; next: string | null; previous: string | null; results: AdminSchool[] };
}

export async function adminCreateSchool(payload: { name: string; creator_type: number; }) {
    const toStr: Record<number, string> = { 1: 'school', 2: 'college', 3: 'university' };
    const body: any = { name: payload.name, inst_type: toStr[payload.creator_type] ?? 'school' };
    const res = await API.post('api/admin/schools/', body);
    return res.data as any;
}

export async function adminUpdateSchool(id: number, patch: Partial<{ name: string; creator_type: number }>) {
    const toStr: Record<number, string> = { 1: 'school', 2: 'college', 3: 'university' };
    const body: any = {};
    if (typeof patch.name === 'string') body.name = patch.name;
    if (typeof patch.creator_type === 'number') body.inst_type = toStr[patch.creator_type] ?? 'school';
    const res = await API.patch(`api/admin/schools/${id}/`, body);
    return res.data as any;
}

export async function adminDeleteSchool(id: number) {
    const res = await API.delete(`api/admin/schools/${id}/`);
    return res.data;
}

export async function adminGetSchoolStudents(schoolId: number, params?: { page?: number; page_size?: number; search?: string }) {
    const page = params?.page ?? 1;
    const page_size = params?.page_size ?? 10;
    const search = params?.search ? `&search=${encodeURIComponent(params.search)}` : '';
    const url = `api/admin/schools/${schoolId}/students/?page=${page}&page_size=${page_size}${search}`;
    const res = await API.get(url);
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : (Array.isArray(raw?.results) ? raw.results : []);
    const mapped = (arr as any[]).map((s) => ({ id: s.id, name: s.name ?? s.username ?? '', grade: s.grade ?? '' })) as AdminStudentBrief[];
    const count = typeof raw?.count === 'number' ? raw.count : mapped.length;
    return { count, next: raw?.next ?? null, previous: raw?.previous ?? null, results: mapped } as { count: number; next: string | null; previous: string | null; results: AdminStudentBrief[] };
}

// Admin - Grades & Subjects per school
export type AdminGrade = { id: number; name: string };
export type AdminSubject = { id: number; name: string };

export async function adminGetSchoolGrades(schoolId: number) {
    const res = await API.get(`api/admin/schools/${schoolId}/grades/`);
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : (Array.isArray(raw?.results) ? raw.results : []);
    return arr as AdminGrade[];
}

export async function adminCreateGrade(schoolId: number, name: string) {
    const res = await API.post(`api/admin/schools/${schoolId}/grades/`, { name });
    return res.data as AdminGrade;
}

export async function adminUpdateGrade(schoolId: number, gradeId: number, name: string) {
    const res = await API.patch(`api/admin/schools/${schoolId}/grades/${gradeId}/`, { name });
    return res.data as AdminGrade;
}

export async function adminDeleteGrade(schoolId: number, gradeId: number) {
    const res = await API.delete(`api/admin/schools/${schoolId}/grades/${gradeId}/`);
    return res.data;
}

export async function adminGetGradeSubjects(schoolId: number, gradeId: number) {
    const res = await API.get(`api/admin/schools/${schoolId}/grades/${gradeId}/subjects/`);
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : (Array.isArray(raw?.results) ? raw.results : []);
    return arr as AdminSubject[];
}

export async function adminCreateSubject(schoolId: number, gradeId: number, name: string) {
    const res = await API.post(`api/admin/schools/${schoolId}/grades/${gradeId}/subjects/`, { name });
    return res.data as AdminSubject;
}

export async function adminUpdateSubject(schoolId: number, subjectId: number, name: string) {
    const res = await API.patch(`api/admin/schools/${schoolId}/subjects/${subjectId}/`, { name });
    return res.data as AdminSubject;
}

export async function adminDeleteSubject(schoolId: number, subjectId: number) {
    const res = await API.delete(`api/admin/schools/${schoolId}/subjects/${subjectId}/`);
    return res.data;
}

// Admin - Assign or create admin user for a school
export async function adminAssignSchoolAdmin(schoolId: number, payload: { user_id?: number; username?: string; password?: string; email?: string; first_name?: string; last_name?: string; }) {
    const res = await API.post(`api/admin/schools/${schoolId}/assign-admin/`, payload);
    return res.data as { id: number; username: string };
}

// Admin - University structures (Fields of Study and Academic Years)
export type AdminField = { id: number; name: string };
export type AdminAcademicYear = { id: number; name: string };
export async function adminGetInstitutionFields(institutionId: number) {
    const res = await API.get(`api/user-info/get-schools/uni/${institutionId}/`);
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : [];
    return arr.map((i: any) => ({ id: i.id, name: i.subject_name ?? i.name })) as AdminField[];
}
// Fetch all fields (superuser use-case)
export async function adminGetAllFields() {
    const res = await API.get(`api/user-info/get-schools/uni-all/`);
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : [];
    return arr.map((i: any) => ({ id: i.id, name: i.subject_name ?? i.name, institution_id: i.institution_id ?? null })) as Array<{ id: number; name: string; institution_id?: number | null }>;
}
export async function adminGetFieldAcademicYears(institutionId: number, fieldId: number) {
    const res = await API.get(`api/user-info/get-schools/uni/${institutionId}/${fieldId}/`);
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : [];
    return arr.map((y: any) => ({ id: y.id, name: y.name })) as AdminAcademicYear[];
}

// Fetch courses for a specific academic year (university flow)
export async function adminGetAcademicYearCourses(institutionId: number, fieldId: number, yearId: number) {
    const res = await API.get(`api/user-info/get-schools/uni/${institutionId}/${fieldId}/${yearId}/courses/`);
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : [];
    return arr.map((c: any) => ({ id: c.id, name: c.name })) as { id: number; name: string }[];
}

export type AdminUserBrief = { id: number; username: string; email?: string; first_name?: string; last_name?: string };
export async function adminGetSchoolAdmins(schoolId: number) {
    const res = await API.get(`api/admin/schools/${schoolId}/admins/`);
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : (Array.isArray(raw?.results) ? raw.results : []);
    return arr as AdminUserBrief[];
}

// Public catalog helpers used by Admin Exams
export type PublicSchool = { id: number; name: string };
export async function publicGetSchools() {
    const res = await API.get('api/exam/schools/');
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : raw?.schools;
    const items = Array.isArray(arr) ? arr : [];
    return items.map((s: any) => ({ id: s.id, name: s.name })) as PublicSchool[];
}
export type PublicGrade = { id: number; name: string };
export async function publicGetSchoolGrades(schoolId: number) {
    const res = await API.get(`api/exam/schools/${schoolId}/grade/`);
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : raw?.grades;
    const items = Array.isArray(arr) ? arr : [];
    return items.map((g: any) => ({ id: g.id, name: g.grade_name ?? g.name })) as PublicGrade[];
}
export type PublicSubject = { id: number; name: string };
export async function publicGetSchoolGradeSubjects(schoolId: number, gradeId: number) {
    const res = await API.get(`api/exam/schools/${schoolId}/grade/${gradeId}/`);
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : raw?.subjects;
    const items = Array.isArray(arr) ? arr : [];
    return items.map((s: any) => ({ id: s.id, name: s.subject_name ?? s.name })) as PublicSubject[];
}

// Search grades globally excluding those already linked to requesting school (server enforces exclusion)
export async function searchGrades(toBeValidated: string | null, q: string) {
    const res = await API.get(
        `api/school/grades/search/`,
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` }, params: { q } }
    );
    const raw = res.data as any;
    const arr = Array.isArray(raw?.grades) ? raw.grades : (Array.isArray(raw) ? raw : []);
    return (arr || []).map((g: any) => ({ id: g.id, name: g.grade_name ?? g.name }));
}

// Join existing chapter by adding current user's institution to chapter.institutions
export async function joinChapter(toBeValidated: string | null, chapterId: number) {
    try {
        const response = await API.post(
            `api/school/chapters/${chapterId}/join/`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${toBeValidated}`,
                },
            }
        );
        return response.data;
    } catch (err) {
        console.error('joinChapter error', err);
        throw err;
    }
}

export async function schoolJoinGrade(toBeValidated: string | null, gradeId: number) {
    const res = await API.post(
        `api/school/grades/${gradeId}/join/`,
        {},
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } }
    );
    return res.data as { grade: { id: number; name: string } };
}
export type PublicExam = { id: number; name: string; sub?: string; grade?: string; price?: string; status?: string; time_given?: number };
export async function publicListExamsBySchoolGradeSubject(schoolId: number, gradeId: number, subjectId: number) {
    const res = await API.get(`api/exam/schools/${schoolId}/grade/${gradeId}/${subjectId}`);
    // Backend uses ExamSerializers for various exam lists
    return res.data as PublicExam[] | { exams: PublicExam[] };
}
export async function publicSearchExams(search: string, subjectId?: number) {
    const payload: any = { search };
    if (subjectId && subjectId > 0) payload.sub_id = String(subjectId);
    const res = await API.post('api/exam/search/new/', payload);
    return res.data as PublicExam[];
}

// School Setup APIs
export async function schoolAddGrade(toBeValidated: string | null, name: string) {
    const res = await API.post(
        'api/school/grades/add/',
        { name },
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } }
    );
    return res.data as { id: number; name: string };
}

export async function schoolAddSubject(toBeValidated: string | null, gradeId: number, name?: string, subjectId?: number) {
    const payload: { name?: string; subject_id?: number } = {};
    if (name) payload.name = name;
    if (subjectId) payload.subject_id = subjectId;

    const res = await API.post(
        `api/school/grades/${gradeId}/subjects/add/`,
        payload,
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } }
    );
    return res.data as { id: number; name: string };
}

export async function getSubjectChaptersApi(toBeValidated: string | null, subjectId: number, gradeId?: number | null) {
    const qp = gradeId != null ? `?grade_id=${encodeURIComponent(String(gradeId))}` : ''
    const res = await API.get(
        `api/school/subjects/${subjectId}/chapters/${qp}`,
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } }
    );
    return res.data as { chapters: { id: number; name: string; school_grades?: number[]; school_grade_ids?: number[]; institutions?: number[] }[] };
}

export async function getPresetInstitutionGradeChapters(presetName: string, gradeId: number, subjectId: number) {
    const res = await API.get(`api/presets/institutions/${encodeURIComponent(presetName)}/grades/${gradeId}/subjects/${subjectId}/chapters/`, { headers: { 'Content-Type': 'application/json' } });
    // return { chapters: [{ id, name, school_grade_ids, institutions }] }
    return res.data as { chapters: { id: number; name: string; school_grade_ids?: number[]; institutions?: number[] }[] };
}

export async function getCourseChapters(toBeValidated: string | null, courseId: number) {
    try {
        const url = `api/school/courses/${courseId}/chapters/`;
        const res = await API.get(url, { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } });
        try {
            console.log(`[remote] getCourseChapters ${courseId} -> status: ${res.status}`, { url, data: res.data });
        } catch (e) { /* ignore console errors */ }
        return res.data as { chapters: { id: number; name: string; subchapters?: { id: number; name: string }[] }[] };
    } catch (err) {
        console.error('getCourseChapters error', err);
        return { chapters: [] } as any;
    }
}

export async function uploadCourseChaptersFromJSON(toBeValidated: string | null, courseId: number, payload: any) {
    try {
        const res = await API.post(
            `api/school/courses/${courseId}/chapters/add-json/`,
            payload,
            { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } }
        );
        return res.data as { created: { id: number; name: string; subchapters: { id: number; name: string }[] }[] };
    } catch (err) {
        console.error('uploadCourseChaptersFromJSON error', err);
        throw err;
    }
}

// ChapterOption helpers (templates) for university/course flow
export async function getCourseChapterOptions(toBeValidated: string | null, courseId: number) {
    try {
        const url = `api/school/courses/${courseId}/chapter-options/`;
        const res = await API.get(url, { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } });
        try {
            console.log(`[remote] getCourseChapterOptions ${courseId} -> status: ${res.status}`, { url, data: res.data });
        } catch (e) { /* ignore console errors */ }
        return res.data as { chapters: { id: number; name: string; subchapters?: { id: number; name: string }[] }[] };
    } catch (err) {
        console.error('getCourseChapterOptions error', err);
        return { chapters: [] } as any;
    }
}

export async function uploadCourseChapterOptionsFromJSON(toBeValidated: string | null, courseId: number, payload: any) {
    try {
        const res = await API.post(
            `api/school/courses/${courseId}/chapter-options/add-json/`,
            payload,
            { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } }
        );
        return res.data as { created: { id: number; name: string; subchapters: { id: number; name: string }[] }[] };
    } catch (err) {
        console.error('uploadCourseChapterOptionsFromJSON error', err);
        throw err;
    }
}

export async function addCourseChapterOptionApi(toBeValidated: string | null, courseId: number, name: string) {
    try {
        const res = await API.post(
            `api/school/courses/${courseId}/chapter-options/add/`,
            { name },
            { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } }
        );
        return res.data as { id: number; name: string };
    } catch (err) {
        console.error('addCourseChapterOptionApi error', err);
        throw err;
    }
}

export async function addSubjectChapterApi(toBeValidated: string | null, subjectId: number, name: string, school_grade_id: number) {
    try {
        const payload: any = { name };
        // Backend expects an array field: school_grade_ids
        if (typeof school_grade_id === 'number') {
            payload.school_grade_ids = [school_grade_id];
        }
        const response = await API.post(
            `api/school/subjects/${subjectId}/chapters/add/`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`,
                },
            }
        );
        return response.data;
    } catch (err) {
        console.log(err);
        return err;
    }
}

export type TeacherBrief = { id: number; username: string; email: string; full_name: string };
export async function listTeachersApi(toBeValidated: string | null) {
    const res = await API.get(
        `api/school/teachers/`,
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } }
    );
    return res.data as { teachers: TeacherBrief[] };
}

export async function listTeacherAssignmentsApi(toBeValidated: string | null, teacherId: number) {
    const res = await API.get(
        `api/school/teachers/${teacherId}/assignments/`,
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } }
    );
    return res.data as { assignments: { subject_id: number; subject_name: string; grade_id: number; grade_name: string }[] };
}

export async function assignTeacherSubjectApi(toBeValidated: string | null, teacherId: number, subjectId: number) {
    const res = await API.post(
        `api/school/teachers/assign/`,
        { teacher_id: teacherId, subject_id: subjectId },
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } }
    );
    return res.data as { stat: string };
}

export async function unassignTeacherSubjectApi(toBeValidated: string | null, teacherId: number, subjectId: number) {
    const res = await API.post(
        `api/school/teachers/unassign/`,
        { teacher_id: teacherId, subject_id: subjectId },
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${toBeValidated}` } }
    );
    return res.data as { stat: string };
}

export async function adminCreateField(institutionId: number, name: string) {
    const res = await API.post(`api/admin/schools/${institutionId}/fields/`, { name });
    return res.data as AdminField;
}

export async function adminExamTransfer(examId: number, payload: { target_institution_id: number; school_subject?: number; course?: number; replicate_chapters?: boolean; replicate_questions?: boolean }) {
    const res = await API.post(`api/admin/exams/${examId}/transfer/`, payload);
    return res.data as { detail: string; exam: any };
}

export async function adminGetSchoolSubjects(schoolId: number) {
    const res = await API.get(`api/admin/schools/${schoolId}/subjects/`);
    const raw = res.data as any;
    const arr = Array.isArray(raw) ? raw : (Array.isArray(raw?.results) ? raw.results : []);
    return arr as AdminSubject[];
}

// Fetch preset institution subjects by preset name (e.g. 'eltest-school' or 'eltest-uni')
export async function getPresetInstitutionGradeSubjects(presetName: string, gradeId: number) {
    const res = await API.get(`api/presets/institutions/${encodeURIComponent(presetName)}/grades/${gradeId}/subjects/`);
    const raw = res.data as any;
    const arr = Array.isArray(raw?.subjects) ? raw.subjects : (Array.isArray(raw) ? raw : []);
    return arr.map((s: any) => ({ id: s.id, name: s.subject_name ?? s.name, institutions: Array.isArray(s.institutions) ? s.institutions : [] })) as { id: number; name: string; institutions?: number[] }[];
}

export async function adminCreateAcademicYear(institutionId: number, fieldId: number, name: string) {
    const res = await API.post(`api/admin/schools/${institutionId}/fields/${fieldId}/academic-years/`, { name });
    return res.data as AdminAcademicYear;
}

export async function getSubChapters(toBeValidated: string | null, chapterId: number | null) {
    if (!chapterId) return { subchapters: [] };
    try {
        const response = await API.get(
            `api/school/chapters/${chapterId}/subchapters/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },
            }
        );
        return response.data;
    } catch (err) {
        console.log(err);
        return err;
    }
}

export async function addSubChapter(data: { toBeValidated: string | null, chapterId: number, name: string }) {
    try {
        const response = await API.post(
            `api/school/chapters/${data.chapterId}/subchapters/`,
            { name: data.name },
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${data.toBeValidated}`,
                },
            }
        );
        return response.data;
    } catch (err) {
        console.log(err);
        return err;
    }
}

export async function getSubjectsList(toBeValidated: string | null) {
    try {
        const response = await API.get(
            `api/school/subjects/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${toBeValidated}`
                },
            }
        );
        return response.data;
    } catch (err) {
        console.log(err);
        return err;
    }
}

export type NationalExamBrief = { id: number; name: string; creator_name?: string };
export async function getNationalExams(target_level?: 'school' | 'college_university') {
    try {
        const params = target_level ? `?target_level=${encodeURIComponent(target_level)}` : '';
        const res = await API.get(`api/exam/national/${params}`);
        const raw = res.data as any;
        const arr = Array.isArray(raw) ? raw : raw?.results ?? [];
        return arr.map((i: any) => ({ id: i.id, name: i.name, creator_name: i.creator_name || 'National' })) as NationalExamBrief[];
    } catch (err) {
        console.log('Failed to fetch national exams', err);
        return [] as NationalExamBrief[];
    }
}

export async function getUserInfo(toBeValidated?: string | null) {
    try {
        const headers = toBeValidated ? { Authorization: `Bearer ${toBeValidated}` } : undefined;
        const res = await API.get('api/user-info/', headers ? { headers } : undefined);
        return res.data as any;
    } catch (err) {
        console.log('Failed to fetch user info', err);
        return {};
    }
}

export async function getSharedNotes(token: string | null) {
    const res = await API.get('api/shared-notes/', {
        headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
}

export async function createSharedNote(token: string | null, data: { title: string; content: string }) {
    const res = await API.post('api/shared-notes/', data, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
}

export async function updateSharedNote(token: string | null, id: number, data: { title: string; content: string }) {
    const res = await API.patch(`api/shared-notes/${id}/`, data, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
}

export async function assignSharedNoteToQuestions(token: string | null, data: { note_id: number; question_ids: number[] }) {
    const res = await API.post('api/shared-notes/assign/', data, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
}

export async function deleteExamQuestion(token: string | null, exam_id: string, question_id: number | string) {
    const res = await API.post(`api/school/exam-detail/${exam_id}/delete-question/`, { question_id }, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
}

export async function deleteExam(token: string | null, exam_id: number | string) {
    const res = await API.post(`api/school/exam-detail/${exam_id}/delete/`, {}, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
}

// Generic request helper: maps a fetch-like call to axios via the `API` instance.
export async function request(url: string, options?: { method?: string; headers?: any; body?: any }) {
    try {
        const method = (options?.method || 'GET').toUpperCase();
        const headers = options?.headers || {};
        // normalize url: remote API functions use paths without leading slash
        const path = url.startsWith('/') ? url.slice(1) : url;
        if (method === 'GET') {
            const resp = await API.get(path, { headers });
            return resp.data;
        }
        if (method === 'POST') {
            let data = options?.body;
            // if body is a JSON string, try to parse it
            if (typeof data === 'string') {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    // leave as-is (e.g., FormData or plain string)
                }
            }
            const resp = await API.post(path, data, { headers });
            return resp.data;
        }
        // fallback generic request for other methods
        const resp = await API.request({ url: path, method, headers, data: options?.body });
        return resp.data;
    } catch (err) {
        console.error('remote.request error', err);
        throw err;
    }
}
